export enum HandoffMethods {
    None = 'none',
    Curbside = 'curbside',
    Delivery = 'delivery',
    Dispatch = 'dispatch',
    Pickup = 'pickup',
}
